import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { DataLineageGitService } from './data-lineage-git.service';

@Injectable({ providedIn: 'root' })
export class DataLineageGitFactoryService extends AbstractGitFactoryService<DataLineageGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: DataLineageGitService,
    });
  }
}
